import _ from 'lodash';
import axios from 'axios';
import csrfToken from '../../../shared/meta';

const base = '/api/v1/lwadmin/partnership';

export function getAll() {
  return axios.get(`${base}s`, { cache: { ignoreCache: true } });
}

export function getById(id) {
  return axios.get(`${base}/${id}`, { cache: { ignoreCache: true } });
}

export function act(id) {
  return axios.post(`${base}/${id}/_activate`);
}

export function deact(id) {
  return axios.post(`${base}/${id}/_deactivate`);
}

export function createOrUpdate(partnership) {
  const url = partnership.id ? `${base}/${partnership.id}` : base;

  return axios.post(
    url,
    {
      ..._.pick(partnership, [
        'id', 'name', 'active', 'send_automatically', 'contact_email',
        'partnership_type', 'dashboard_url',
      ]),
      account_manager_id: _.get(partnership, 'account_manager.id', null),
      contributor_ids: partnership.contributors.filter(c => c.active).map(c => c.id),
      company_ids: partnership.companies.map(c => c.id),
    },
    { headers: { 'X-CSRF-TOKEN': csrfToken() } },
  );
}

export function toggleArchivingStatus(contactId) {
  return axios.post(
    `${base}_contacts/${contactId}/_toggle_archiving_status`,
    null,
    { headers: { 'X-CSRF-TOKEN': csrfToken() } },
  );
}

export function getContact(pid, cid) {
  return axios.get(`${base}/${pid}/contact/${cid}`);
}

export function sendContact(pid, cid) {
  return axios.post(
    `${base}/${pid}/contact/${cid}/_send`,
    null,
    { headers: { 'X-CSRF-TOKEN': csrfToken() } },
  );
}
